import React, {useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import GeneralDialog from "../GeneralDialog";
import SurveyComponent from "../../Survey/SurveyComponent";
import Utilty from "../../../Utility";
import ConditionalComponent from "../../Shared/ConditionalComponent";


const SurveyModal = observer(() => {
    const {modalStore, generalStore, surveyStore} = useStores();

    const [surveyName, setSurveyName] = useState(
        ""
    );

    const trimmedName = surveyName.trim();
    const skipSurvey = async () => {
        await surveyStore.skipSurvey()

    }
    const renderBody = () => {
        return (
            <SurveyComponent/>
        );
    };

    const onEnter = () => setSurveyName(surveyStore.currentSurvey.surveyName || "");

    return (Utilty.isMobile() ?
            <ConditionalComponent if={modalStore.isSurveyOpen}>
                <div className="fixed inset-0 w-full h-full flex justify-center items-start overflow-auto"
                     style={{
                         backgroundColor: 'var(--background-normal-color)',
                         zIndex: 2002,
                         paddingTop: '5vh',
                         paddingLeft: '5%',
                         paddingRight: '5%'
                     }}>{renderBody()}</div>
            </ConditionalComponent>
            :
            <GeneralDialog
                maxWidth={false}
                fullWidth
                maxHeight
                openControl="isSurveyOpen"
                dialogStyle={{
                    backgroundColor: 'var(--background-normal-color)',
                    boxShadow: 'none',
                    width: '80vw',
                    maxWidth: '1100px',
                    height: '100vh'
                }}
                onEnter={onEnter}
                body={renderBody()}
                specialOnClose={skipSurvey}
                isConfirmDisabled
            />
    );
});

export default SurveyModal;
